import { IMAGE_URL } from '@/constant/IMAGE'
import Table from '@/components/common/Table'
import { Button, ContainerCard, HeaderWrapper, IconSvg } from './styles'
import DeleteSystemApprovalClaimModal from '../DeleteSystemApprovalClaimModal'
import TableSystemApprovalHook from './TableSystemApproval.hook'
import CreateApproveLevelClaimModal from '../CreateApproveLevelClaimModal'

const TableSystemApproval = () => {
  const {
    columns,
    queryListHealthClaimUserApprove,
    validatePerm,
    BACKOFFICE_USER_PERMISSION,
    user,
    setCreateClaimApprovalLevelModal,
  } = TableSystemApprovalHook()

  return (
    <ContainerCard>
      <HeaderWrapper>
        {validatePerm([BACKOFFICE_USER_PERMISSION.APP010202], user.permissions) ? (
          <Button
            type="primary"
            icon={<IconSvg src={IMAGE_URL.plusIcon} />}
            data-testid="system-approval-add-button"
            onClick={() =>
              setCreateClaimApprovalLevelModal({
                open: true,
                onSuccess: () => {
                  queryListHealthClaimUserApprove.refetch()
                },
              })
            }
          >
            เพิ่มระดับอนุมัติ
          </Button>
        ) : null}
      </HeaderWrapper>
      <Table
        columns={columns}
        dataSource={queryListHealthClaimUserApprove.data}
        loading={queryListHealthClaimUserApprove.isLoading}
      />
      <CreateApproveLevelClaimModal />
      <DeleteSystemApprovalClaimModal />
    </ContainerCard>
  )
}

export default TableSystemApproval
